import data from "../../../../../packages/react/src/DataTable/DataTable.docs.json";
import * as React from 'react';
export default {
  data,
  React
};